export const getEducationalSectionContent = ({ i18n }) => ({
  title: i18n.gettext('Disfruta hoy y paga después'),
  /* i18n-next-line only: ["pt-BR", "es-MX"] */
  subtitle: i18n.gettext('Pagar en cuotas sin tarjeta en tiendas online es así de fácil'),
  steps: {
    one: {
      imageName: 'carrito',
      title: i18n.gettext('Ingresa a una tienda y elige lo que quieras'),
    },
    two: {
      imageName: 'mc',
      title: i18n.gettext('Selecciona Mercado Pago al momento de pagar'),
    },
    three: {
      imageName: '12x',
      title: i18n.gettext('Elige "Cuotas sin Tarjeta" y la cantidad de cuotas'),
    },
    four: {
      imageName: 'mp',
      title: i18n.gettext('Paga mes a mes desde la App de Mercado Pago'),
    },
  },
});
